// export const API_URL = import.meta.env.VITE_API_URL;
// export const AI_API_TOKEN = import.meta.env.VITE_AI_API_TOKEN;
// export const AI_API_URL = import.meta.env.VITE_AI_API_URL;
// export const RESUME_APP_URL = import.meta.env.VITE_RESUME_UPLOAD_URL;

// export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

// export const LINKEDIN_CLIENT_ID = import.meta.env.VITE_LINKEDIN_CLIENT_ID;
// export const LINKEDIN_CLIENT_SECRET = import.meta.env.VITE_LINKEDIN_CLIENT_SECRET;
// export const LINKEDIN_REDIRECT_URL = import.meta.env.VITE_LINKEDIN_REDIRECT_URL;
// export const LINKEDIN_SCOPES = import.meta.env.VITE_LINKEDIN_SCOPES

export const API_URL = process.env.REACT_APP_API_URL;
export const AI_API_TOKEN = process.env.REACT_APP_AI_API_TOKEN;
export const AI_API_URL = process.env.REACT_APP_AI_API_URL;
export const RESUME_APP_URL = process.env.REACT_APP_RESUME_UPLOAD_URL;

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
export const LINKEDIN_CLIENT_SECRET =
  process.env.REACT_APP_LINKEDIN_CLIENT_SECRET;
export const LINKEDIN_REDIRECT_URL =
  process.env.REACT_APP_LINKEDIN_REDIRECT_URL;
export const LINKEDIN_SCOPES = process.env.REACT_APP_LINKEDIN_SCOPES;
